/**
 * schema/preview.ts — rule dry-run (POST /v1/rules/preview).
 */
export type DropReason = 'unavailable' | 'dietary' | 'price_delta' | 'compatibility' | 'exclude_in_cart';

export interface PreviewCandidate {
  item_id: string;
  name: string;
  /** Price in minor display units (₹) — used for the candidate rows. */
  price?: number;
  eligible: boolean;
  drop_reason?: DropReason;
}

export interface PreviewPick {
  item_id: string;
  name: string;
  price?: number;
  phrasing: string;
}

export interface PreviewResult {
  matched: boolean;
  /** Trigger sample item the engine evaluated against. */
  trigger?: { item_id: string; name: string; price?: number };
  candidate_pool: PreviewCandidate[];
  pick: PreviewPick | null;
  pick_reason: string;
}

/** Human label for a dropped candidate (matches the design's red reasons). */
export const DROP_LABEL: Record<DropReason, string> = {
  unavailable: '86’d — unavailable',
  dietary: 'dietary mismatch',
  price_delta: 'over price-delta',
  compatibility: 'incompatible',
  exclude_in_cart: 'already in cart',
};
